<template>
  <div >
    <!-- top -->
    <div class="top">
      <div class="top_inner">
        <el-col :span="12" class="top_left">
          <i class="iconfont icon_top_tel">&#xe634;</i>服务热线：400 029 7800 (早8:30~晚17:30)
          <i class="iconfont icon_top_ring">&#xe6cc;</i>投资有风险 出借需谨慎!
        </el-col>
<!--      <el-col :span="12" class="top_right">
          <span>当前用户：{{username||'游客'}}，</span>
          <span v-if="isLogin===null||!isLogin">
            <router-link :to="{ path: '/register' }">注册</router-link> |
            <router-link :to="{ path: '/login' }">登录</router-link>
          </span>

          <el-dropdown placement="top"  v-if="isLogin">
            <span class="el-dropdown-link">
              用户中心<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="getUCenter(1)">个人信息</el-dropdown-item>
               <el-dropdown-item @click.native="getUCenter(2)">修改密码</el-dropdown-item>
               <el-dropdown-item @click.native="getUCenter(3)">我的借贷</el-dropdown-item>
              <el-dropdown-item @click.native="getUCenter(4)">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col> -->
      </div>
    </div><!-- top END -->

    <!-- header -->
    <div class="header">
      <div class="header_inner">
        <el-col :span="8"><router-link :to="{ path: '/' }"  class="logo">普惠借贷</router-link></el-col>
        <el-col :span="16" class="nav">

          <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" menu-trigger>
            <el-submenu index="1">
              <template slot="title">平台概况</template>
              <el-menu-item index="1-1"><router-link :to="{ path: '/centerIntroduce' }">平台简介</router-link></el-menu-item>
              <el-menu-item index="1-2"><router-link :to="{ path: '/serviceScope' }">服务模式</router-link></el-menu-item>
              <el-menu-item index="1-3"><router-link :to="{ path: '/managementAim' }">经营宗旨</router-link></el-menu-item>
              <!-- <el-menu-item index="1-3"><router-link :to="{ path: '' }">社会价值和目标</router-link></el-menu-item> -->
              <!-- <el-menu-item index="1-4"><router-link :to="{ path: '/platformAdvantage' }">平台优势</router-link></el-menu-item> -->
              <!-- <el-menu-item index="1-5"><router-link :to="{ path: '/organizationalStructure' }">组织架构</router-link></el-menu-item> -->
              <el-menu-item index="1-6"><router-link :to="{ path: '/contactUs' }">联系我们</router-link></el-menu-item>
            </el-submenu>
            <!-- <el-submenu index="2"> -->
              <!-- <template slot="title">业务流程</template> -->
              <!-- <el-menu-item index="2-1"><router-link :to="{ path: '/borrowProcess' }">借贷服务</router-link></el-menu-item> -->
              <!-- <el-menu-item index="2-2"><router-link :to="{ path: '/debtTransferProcess' }">债权转让服务</router-link></el-menu-item> -->
              <!-- <el-menu-item index="2-3"><router-link :to="{ path: '/ecInvestmentProcess' }">股权/基金投资服务</router-link></el-menu-item> -->
              <!-- <el-menu-item index="2-4"><router-link :to="{ path: '/dataDownload' }">资料下载</router-link></el-menu-item> -->

            <!-- </el-submenu> -->
<!--             <el-submenu index="3">
              <template slot="title">借贷大厅</template>
              <el-menu-item index="3-1"><router-link :to="{ path: '/borrowProject' }">借入项目</router-link></el-menu-item>
              <el-menu-item index="3-2"><router-link :to="{ path: '/loanProject' }">出借项目</router-link></el-menu-item>
              <el-menu-item index="3-3"><router-link :to="{ path: '/assignmentDebt' }">债权转让</router-link></el-menu-item>
            </el-submenu> -->
            <!--<el-submenu index="4">
              <template slot="title">股权/基金投资</template>
              <el-menu-item index="4-1"><router-link :to="{ path: '/ecInvestmentIntroduction' }">股权/基金投资介绍</router-link></el-menu-item>-->
              <!-- <el-menu-item index="4-2"><router-link :to="{ path: '/efInvestmentProject' }">股权/基金投资项目</router-link></el-menu-item> -->
              <!-- <el-menu-item index="4-3"><router-link :to="{ path: '/successfulCase' }">成功案例</router-link></el-menu-item> -->
            <!--</el-submenu>-->
            <!-- <el-submenu index="5"> -->
              <!-- <template slot="title">资讯中心</template>
              <el-menu-item index="5-1"><router-link :to="{ path: '/notificationAnnouncement' }">通知公告</router-link></el-menu-item>
              <el-menu-item index="5-2"><router-link :to="{ path: '/centerNews' }">平台新闻</router-link></el-menu-item>
              <el-menu-item index="5-3"><router-link :to="{ path: '/industryInformation' }">行业资讯</router-link></el-menu-item>
              <el-menu-item index="5-4"><router-link :to="{ path: '/investmentExpress' }">投资快讯</router-link></el-menu-item>
              <el-menu-item index="5-5"><router-link :to="{ path: '/communicationCooperation' }">交流合作</router-link></el-menu-item>
              <el-menu-item index="5-6"><router-link :to="{ path: '/caseShow' }">案例展示</router-link></el-menu-item> -->

            <!-- </el-submenu> -->
            <!-- <el-submenu index="6"> -->
              <!-- <template slot="title">政策法规</template>
              <el-menu-item index="6-1"><router-link :to="{ path:'/policiesRegulations' }">政策法规</router-link></el-menu-item>
              <el-menu-item index="6-2"><router-link :to="{ path:'/BorrowingKnowledge' }">借贷知识</router-link></el-menu-item> -->

            <!-- </el-submenu> -->
            <!-- <el-menu-item index="7"><router-link :to="{ path:'/contactUs' }">联系我们</router-link></el-menu-item> -->

            <el-menu-item index="2"><router-link :to="{ path:'' }">信息登记</router-link></el-menu-item>
            <el-menu-item index="5"><router-link :to="{ path:'' }">法律支持</router-link></el-menu-item>
            <el-menu-item index="6"><router-link :to="{ path:'' }">相关服务</router-link></el-menu-item>
            <el-menu-item index="7"><router-link :to="{ path:'' }">信息披露</router-link></el-menu-item>
          </el-menu>

        </el-col>
      </div>
    </div><!-- header END -->

  </div>
</template>
<script>
    import {reqValidateWebUser} from '../api/projectManagement-api';
    import {reqUserNameByToken} from '../api/webUser-api';
    export default {
      data(){
          return{
              clientUserName:'',
              activeIndex: '1',
          }
      },
      computed: {
        username() {
          return this.$store.getters.username;
        },
        isLogin() {
          return this.$store.getters.isLogin;
        },
        type() {
          return this.$store.getters.type;
        },
      },
      methods:{
          handleSelect(key, keyPath) {
            console.log(key, keyPath);
          },
          getUCenter(uCenter){
              var that=this;
              reqValidateWebUser().then((res)=>{
                  console.log(res)
                  if(res.data.code==1){
                      if(uCenter==1){
                          that.$router.push('/personalInformation');
                      }
                      if(uCenter==2){
                          that.$router.push('/passwordEdit');
                      }
                      if(uCenter==3){
                          that.$router.push('/myBorrow');
                      }
                      if(uCenter==4){
                          this.$confirm('确认退出吗?', '提示', {
                              //type: 'warning'
                          }).then(() => {
                              that.$store.dispatch('user_logout');
                              sessionStorage.removeItem('Authorization');
                              that.$router.push('/');
                          }).catch(() => {

                          });
                      }
                  }
              })
          },

          getUserNameByToken:function (token) {
              reqUserNameByToken({token:token}).then((res)=>{
                  if(res.data.code===1){
                      this.clientUserName=res.data.data;
                  }else {
                      this.clientUserName='无法识别身份';
                  }
              })
          },
      },mounted(){
           var token = sessionStorage.getItem('Authorization');
           if(token){
               this.getUserNameByToken(token);
           }else {
               this.clientUserName='游客'
           }
      },
  }
</script>



// WEBPACK FOOTER //
// src/components/MyHeader.vue